import { Component, OnInit } from '@angular/core';
import { MenuService } from '@app/shared/services/menu.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-user-tab',
  templateUrl: './user-tab.component.html',
  styleUrls: ['./user-tab.component.scss']
})
export class UserTabComponent implements OnInit {

  public id;

  constructor(
    public menu: MenuService,
    public route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id');
  }

}
